<template>
    <div id="app" :class="[$store.state.isfull?'appfull':'appnormal']">
        <Cheader v-show="isshowheaderfooter" :topcollegeid="topcollegeid" @showlogin="showlogin"></Cheader>
        <router-view @showheaderfooter="setheaderfooter" @settopcollegeid="settopcollegeid" @hidepop="hidepop" />
        <Cfooter v-show="isshowheaderfooter"></Cfooter>
        <el-dialog :visible.sync="isshowpop" v-if="isshowpop" top="0px">
            <pop :popurl="popurl" :poptype.sync="poptype" @hidepop="hidepop"></pop>
        </el-dialog>
    </div>
</template>

<script>

    import Cheader from '@/components/Cheader';
    import Cfooter from '@/components/Cfooter';
    import pop from '@/views/pop';

    export default {
        name: 'app',
        data() {
            return {
                'isshowheaderfooter': true,
                'topcollegeid': 0,
                'isshowpop': false,
                'popurl': 'login',
                'poptype': 1
            }
        },
        components: {
            Cheader,
            Cfooter,
            pop
        },
        /*created() {
            this.$store.dispatch('setlangdic');//异步加载字典
        },*/
        methods: {
            setheaderfooter(v) {
                this.isshowheaderfooter = v;
            },
            settopcollegeid(v) {
                this.topcollegeid = v;
            },
            showpop() {
                this.isshowpop = true;
            },
            hidepop() {
                this.isshowpop = false;
            },
            showlogin(v) {
                this.popurl = 'login';
                this.poptype = v;
                this.isshowpop = true;
            }
        },
        mounted() {//阻止#链接
            let aprevent = (e, href) => {

                href = this.$common.basic.chempty(href) ? "" : href.substring(href.length - 1)
                if (href == "#") {
                    if (e.preventDefault) {
                        e.preventDefault();
                    } else {
                        e.returnValue = false;
                    }
                    //return false;
                }
            };

            document.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    aprevent(e, e.target.href);
                }
                else {
                    if (e.target.parentNode.tagName === 'A') {
                        aprevent(e, e.target.parentNode.href);
                    }
                }
            });

            window.onresize = () => {
                this.$store.commit('SET_WINDOWSIZE');
            }
        }
    };
</script>
